export default __webpack_public_path__ + "static/media/pisces.3fe5447e.png";